import { Server } from './server';
import { Service, ServiceResponse } from './service';

const NOTIFICATIONS_CACHE_EXPIRATION = 60 * 60 * 24;

export class NotificationsService extends Service {
  public async init(): Promise<ServiceResponse> {
    await Server.database.purge('NOTIFICATIONS', NOTIFICATIONS_CACHE_EXPIRATION);
    return {success: true};
  }

  // cache
  public async setMessagesCache(messages:any[], update:boolean = false) {
    await Server.database.putItem(`NOTIFICATIONS`, messages, update);
  }

  public async getMessagesCache() {
    return await Server.database.getItem(`NOTIFICATIONS`, NOTIFICATIONS_CACHE_EXPIRATION);
  }

  // service
  public async getMessages(params:any) {
    let response = await this.sendCommand('user/v3', 'get-notifications', params);

    if(response.status != 200) 
      return {success: false, message: response.body.message};
    
    return {success: true, messages: response.body.messages};
  }
}
